<template>
  <div class="param-type-box">
    <div>类型：</div>
    <div class="common-select-box">
      <el-select
        size="small"
        class="primary-select"
        :popper-append-to-body="false"
        v-model="currParamType"
        @change="handleParamTypeChange">
        <el-option
          v-for="(item, index) in paramTypeList"
          :key="index"
          :title="item.paramsType"
          :label="item.paramsType"
          :value="item.paramsType" />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currParamType: ''
    }
  },
  props: {
    paramTypeList: Array,
    handleParamTypeChange: Function
  },
  mounted() {
    this.currParamType = this.paramTypeList[0].paramsType
  }
}
</script>

<style lang="less" scoped>
.param-type-box {
  display: flex;
  align-items: center;
  margin: 8px 0px;
  font-size: 14px;

  .common-select-box {
    flex-grow: 1;
    text-align: left;

    .el-select {
      width: 100%;
    }
  }
}
</style>
